import PropTypes from "prop-types";
import { Container, Grid } from "@mui/material";
import { NavLink } from "react-router-dom";

import { appRoutes } from "routes";
import { useRouter } from "hooks";

import { StyledAppBar, StyledLink } from "./styles";

const LegalLayout = (props) => {
  const { children } = props;
  const {
    camelizedQuery: { readable },
  } = useRouter();
  const readableView = readable ? readable === "true" : false;

  return (
    <div>
      {!readableView && (
        <StyledAppBar position="static">
          <Container>
            <Grid container>
              <Grid item xs={6} sm={3}>
                <StyledLink to={appRoutes.legalPath()} component={NavLink}>
                  Legal Notices
                </StyledLink>
              </Grid>
              <Grid item xs={6} sm={3}>
                <StyledLink to={appRoutes.termsOfServicePath()} component={NavLink}>
                  Terms of Service
                </StyledLink>
              </Grid>
              <Grid item xs={6} sm={3}>
                <StyledLink to={appRoutes.privacyPath()} component={NavLink}>
                  Privacy Policy
                </StyledLink>
              </Grid>
              <Grid item xs={6} sm={3}>
                <StyledLink to={appRoutes.termsOfSalePath()} component={NavLink}>
                  Terms of Sale
                </StyledLink>
              </Grid>
            </Grid>
          </Container>
        </StyledAppBar>
      )}

      <Container>{children}</Container>
    </div>
  );
};

LegalLayout.propTypes = {
  children: PropTypes.node,
};

export default LegalLayout;
